import { makeStyles } from '@material-ui/core';
import Tooltip from '@marqvision/mds/core/Tooltip';
import { MDSChip } from '@marqvision/mds/core';
import { MDSIcon } from '@marqvision/mds-v2';
import { UseListingNavigationType } from '../../hooks';
import { ArrowLeftIcon } from './ArrowLeftIcon';
import { ArrowRightIcon } from './ArrowRightIcon';
const useStyles = makeStyles(() => ({
  rightButtonWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  tooltip: {},
  tooltipIcon: {
    verticalAlign: 'middle',
  },
}));
export const ListingNavigationButton = ({ hasPrev, hasNext, onPrev, onNext }: UseListingNavigationType) => {
  const classes = useStyles();
  return (
    <div className={classes.rightButtonWrapper}>
      <Tooltip
        title={
          <span className={classes.tooltip}>
            Use <ArrowLeftIcon /> on the keyboard
          </span>
        }
      >
        <MDSChip
          variant="outline"
          color="bluegray"
          label=""
          icon={<MDSIcon.TailArrowLeft />}
          disabled={!hasPrev}
          onClick={onPrev}
        />
      </Tooltip>
      <Tooltip
        title={
          <span className={classes.tooltip}>
            Use <ArrowRightIcon /> on the keyboard
          </span>
        }
      >
        <MDSChip
          variant="outline"
          color="bluegray"
          label=""
          endIcon={<MDSIcon.TailArrowRight />}
          disabled={!hasNext}
          onClick={onNext}
        />
      </Tooltip>
    </div>
  );
};
